import React from 'react';
import PropTypes from 'prop-types';

const parseMetadataJson = text => {
  if (!text || typeof text !== 'string') {
    return undefined;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return undefined;
  }
};

const serializeMetadataForScriptTag = json => JSON.stringify(json)
  .replace(/</g, '\\u003c')
  .replace(/>/g, '\\u003e')
  .replace(/&/g, '\\u0026')
  .replace(/\u2028/g, '\\u2028')
  .replace(/\u2029/g, '\\u2029');

const isValidMetadataObjectOrArray = metadataJson => {
  if (!metadataJson) {
    return false;
  }

  return typeof metadataJson === 'object';
};

const getSeoJsonLdData = content => {
  const items = content.items || [];
  const parsedItems = items.reduce((result, item) => {
    const parsedItem = parseMetadataJson(item && item.json && item.json.text);

    if (!isValidMetadataObjectOrArray(parsedItem)) {
      return result;
    }

    if (Array.isArray(parsedItem)) {
      return result.concat(parsedItem.filter(isValidMetadataObjectOrArray));
    }

    result.push(parsedItem);
    return result;
  }, []);

  if (parsedItems.length === 0) {
    return undefined;
  }

  if (parsedItems.length === 1) {
    return parsedItems[0];
  }

  return parsedItems;
};

const SeoJsonLd = ({ content }) => {
  const parsedMetadataJson = getSeoJsonLdData(content);

  if (!isValidMetadataObjectOrArray(parsedMetadataJson)) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: serializeMetadataForScriptTag(parsedMetadataJson) }}
    />
  );
};

SeoJsonLd.propTypes = {
  content: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      json: PropTypes.shape({
        text: PropTypes.string,
      }),
    })),
  }).isRequired,
};

export default SeoJsonLd;
export { serializeMetadataForScriptTag };
